import React, { useMemo, useState } from 'react';
import { useBusinessInfoContext } from 'contexts/BusinessContextProvider';
import useChangePage from 'hooks/useChangePage';
import useTrackAmplitudeEvent from 'hooks/useTrackAmplitudeEvent';
import { TRIAL_URL } from 'routes/constants';
import useTrialProtectedPageGuard from 'components/Trials/hooks/useTrialProtectedPageGuard';
import BusinessInfoContent from './BusinessInfoContent';
import RoiModal from '../RoiModal';
import BusinessInfoAnimations from 'components/Trials/RoiView/BusinessInfo/BusinessInfoAnimations';

const BusinessInfo = () => {
  const { validateBusinessInfo, businessName, gmb, businessInfo } =
    useBusinessInfoContext() || {};

  const changePage = useChangePage();
  const trackEvent = useTrackAmplitudeEvent('trials.businessInfo.visited');

  useTrialProtectedPageGuard({
    shouldHaveValidLogin: true,
    shouldHaveVerifiedAccount: true,
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = () => {
    setIsSubmitting(true);
    const isValid = validateBusinessInfo();
    trackEvent('trials.businessInfo.nextClicked');

    if (isValid) changePage(`${TRIAL_URL}/loading`, true);
    setIsSubmitting(false);
  };

  const reviewContent = useMemo(() => {
    const businessReview = businessInfo?.gmbReviews?.find(
      (review) => review.rating === 5
    );

    return businessReview
      ? {
          authorName: businessReview.author_name,
          text: businessReview.text,
          profilePhotoUrl: businessReview.profile_photo_url,
          relativeTimeDescription: businessReview.relative_time_description,
        }
      : {
          authorName: 'Kathryn Murphy',
          text: 'I had a great experience! The team was very helpful and customer service is top notch.',
        };
  }, [businessInfo]);

  return (
    <RoiModal
      progress={66}
      primaryCta="Continue"
      onPrimaryCtaClick={handleSubmit}
    >
      <BusinessInfoContent isSubmitting={isSubmitting} />
      <BusinessInfoAnimations
        businessName={businessName}
        showReview={gmb?.placeId}
        reviewContent={reviewContent}
      />
    </RoiModal>
  );
};

export default BusinessInfo;
